// Disease Risk — Phase 4. Smith-Kerns dollar spot, brown patch, Pythium,
// anthracnose, and snow mold risk scored from weather history. The
// existing DiseaseRiskCard already renders today + the trailing history
// band, so this page is mostly a framing wrapper.

import { useParams } from 'react-router-dom';
import { PageHeader } from '../components/ui/page-header';
import { DiseaseRiskCard } from '../components/DiseaseRiskCard.js';

export function DiseaseRiskPage() {
  const { courseSlug } = useParams();
  if (!courseSlug) return null;
  return (
    <div className="max-w-6xl p-6 md:p-10">
      <PageHeader
        eyebrow="Phase 4"
        title="Disease Risk"
        description="Turf disease risk scored from weather history — dollar spot, brown patch, Pythium, anthracnose, and snow mold. Anything yellow or red is worth a scouting round today."
      />
      <div className="mt-8">
        <DiseaseRiskCard courseSlug={courseSlug} />
      </div>
    </div>
  );
}
